import { createFileRoute } from "@tanstack/react-router";
import { CORRIDORS, CorridorPage, corridorHead } from "@/lib/corridors";

const corridor = CORRIDORS["agadir-to-taghazout-surf"];

export const Route = createFileRoute("/transfers/agadir-to-taghazout-surf")({
  head: () => corridorHead(corridor),
  component: () => <CorridorPage corridor={corridor} />,
});
